<template>
    <div class="warpper padding-sm">
        <div class="page-title line-height">短信套餐</div>
        <div class="count flex align-center justify-center">
            短信剩余条数：{{ smsNumber }}
        </div>
        <div class="page-title line-height margin-top">购买短信</div>
        <div class="flex flex-wrap margin-top-xs">
            <div v-for="(item,index) in meals"
                 :key="index"
                 :class="{active:meal_id === item.id}" class="item flex flex-direction align-center justify-center" @click="meal_id = item.id">
                <div class="number">{{ item.smsNumber }}条</div>
                <div class="money margin-top">{{ item.payMoney }}元</div>
            </div>
        </div>
        <el-button class="blue-btn self-center margin-top" @click="paySms">
            购买
        </el-button>
        <div v-show="qrcodeUrl" class="qrcode">
            <qrcode v-if="qrcodeUrl"
                    :size="250"
                    :text="qrcodeUrl"
                    class="margin-top-xl">
            </qrcode>
            <p class="tips">请使用微信扫码支付</p>
            <el-button circle icon="el-icon-close" type="info" @click="cancel"></el-button>
        </div>
        <result-message-dialog :applyDialogVisible="dialogSuccessVisible" :iconVisible="true"
                               :iconfont="'el-icon-success'" :tips="msg_tip" :title="msg_title" @watchState="watchState"></result-message-dialog>
    </div>
</template>

<script>
import Qrcode from 'vue-qr'
import ResultMessageDialog from "@/components/ResultMessageDialog.vue";
import {checkSMSOrder, createSMSOrder, getSMSSetMeal, getSMSShengYuNumber} from "@/api/organiz";

export default {
    name: "billing",
    data() {
        return {
            smsNumber: 0,
            meal_id: '',
            meals: [],
            qrcodeUrl: '',
            msg_title: '',
            msg_tip: '',
            dialogSuccessVisible: false,
            timer: '',
            order_no: '',
        }
    },
    computed: {},
    created() {
        this.$emit('setIndex', [4, 6], '短信套餐')
        this.init()
    },
    components: {
        ResultMessageDialog,
        qrcode: Qrcode
    },
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        async init() {
            let _data = await getSMSShengYuNumber()
            this.smsNumber = _data.data
            _data = await getSMSSetMeal()
            this.meal_id = _data.data[0].id
            this.meals = _data.data
        },
        async paySms() {
            let _data = await createSMSOrder(this.meal_id)
            if (_data.status === 200) {
                this.order_no = _data.data.order_number
                this.qrcodeUrl = _data.data.url
                let _this = this
                this.timer = setInterval(function () {
                    //执行内容
                    _this.checkPayState()
                }, 3000);
            } else {
                this.$message.error(_data.msg)
            }
        },
        async checkPayState() {
            let _data = await checkSMSOrder(this.order_no)
            if (_data.status === 200) {
                if (_data.data) {
                    this.qrcodeUrl = ''
                    this.order_no = ''
                    clearInterval(this.timer);
                    this.msg_title = '微信支付'
                    this.msg_tip = '支付成功'
                    this.dialogSuccessVisible = true
                    this.init()
                }
            }
        },
        cancel(){
            this.qrcodeUrl = ''
            clearInterval(this.timer);
        },
        watchState(state) {
            this.dialogSuccessVisible = false;
            if (state) this.toBack()
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 30px;

    .count {
        width: 100%;
        height: 184px;
        border-radius: 6px;
        display: flex;
        background: #0A2240;
        margin-top: 36px;
        font-size: 40px;
        font-weight: 600;
        line-height: 60px;
        color: #fff;
    }

    .item {
        height: 176px;
        width: 136px;
        border: 1px solid #0A2240;
        border-radius: 8px;
        cursor: pointer;

        &:not(:nth-child(6n+1)) {
            margin-left: 20px;
        }

        &.active {
            background: #0A2240;

            .number {
                color: #ffffff;
            }

            .money {
                color: #ffffff;
            }
        }

        .number {
            font-size: 30px;
            line-height: 30px;
            font-weight: bold;
            color: #0A2240;
        }

        .money {
            font-size: 20px;
            color: #0A2240;
        }
    }

    .qrcode {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #00000099;
        text-align: center;
        z-index: 99;

        .tips {
            font-size: 16px;
            color: white;
            margin: 30px;
        }
    }
}
</style>